import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import { Link } from 'react-router-dom';

import { MdOutlineHideImage, MdOutlineImage } from 'react-icons/md'
import { BsFillArrowRightSquareFill, BsArrowRightShort, BsFillArrowLeftSquareFill, BsArrowLeftShort } from 'react-icons/bs'
import { CgArrowsMergeAltH } from 'react-icons/cg';

import MainMenu from '../containers/SavedMenu';
import About from './About';
import Terms from './Terms';
import SearchReddit from '../containers/SearchReddit';
import SavedSubreddits from '../containers/SavedSubreddits';
import VisitedSubreddits from '../containers/VisitedSubreddits';

import moreReducer from '../store/reducers/more';

function isMobile() {
	return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

const Footer = props => {
	const [terms, setTerms] = useState(false);
	const [menu, setMenu] = useState(false);
	const [about, setAbout] = useState(false);
	const [showingTab, setShowingTab] = useState('none');
	const [showFooterButtons, setShowFooterButtons] = useState(true);
	const lastScrollY = useRef(typeof window !== "undefined" ? window.scrollY : 0);

	// Only on mobile: hide footer buttons on scroll down, show on scroll up
	useEffect(() => {
		if (!isMobile()) return;

		const columns = Array.from(document.getElementsByClassName("mobile-column"));
		const lastScrollTops = columns.map(col => col.scrollTop);

		const handleScroll = (idx) => (e) => {
			const currentScrollTop = e.target.scrollTop;
			if (currentScrollTop > lastScrollTops[idx] + 5) {
				setShowFooterButtons(false);
			} else if (currentScrollTop < lastScrollTops[idx] - 10) {
				setShowFooterButtons(true);
			}
			lastScrollTops[idx] = currentScrollTop;
		};

		columns.forEach((col, idx) => {
			col.__footerScrollHandler = handleScroll(idx);
			col.addEventListener('scroll', col.__footerScrollHandler, { passive: true });
		});

		return () => {
			columns.forEach((col) => {
				if (col.__footerScrollHandler) {
					col.removeEventListener('scroll', col.__footerScrollHandler);
					delete col.__footerScrollHandler;
				}
			});
		};
	}, []);

	const toggleMenu = () => {
		setMenu(!menu);
	}

	const closeMenu = () => {
		setMenu(false);
	}

	const toggleAbout = () => {
		setAbout(!about);
	}

	const toggleTerms = () => {
		setTerms(!terms);
	}

	const footerStyle = isMobile()
		? { position: "fixed", bottom: 0, left: 0, width: "100%", zIndex: 1000 }
		: undefined;

	// Mobile arrows logic
	const { mobileColumnIndex, setMobileColumnIndex } = props;
	const showMobileArrows = isMobile();

	let mobileFooterArrows = null;

	if (showMobileArrows && showingTab === 'none' && typeof mobileColumnIndex === "number" && typeof setMobileColumnIndex === "function") {
		const navBarStyle = {
			marginBottom: "5px",
			left: 0,
			width: "100%",
			display: "flex",
			justifyContent: mobileColumnIndex === 1 ? "space-between" : "flex-start",
			zIndex: 1100,
			pointerEvents: "none",
			transition: "transform 0.35s cubic-bezier(0.4,0,0.2,1)",
			transform: isMobile() && !showFooterButtons ? "translateY(56px)" : "translateY(0)" // 56px = typical mobile footer height
		};
		const arrowBtnStyle = {
			background: "#e0e0e0",
			color: "#333",
			border: "none",
			borderRadius: "18px",
			width: "45vw",
			height: 32,
			fontSize: 24,
			marginLeft: 8,
			marginRight: 8,
			boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
			opacity: 1,
			cursor: "pointer",
			pointerEvents: "auto",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			marginBottom: "5px"
		};
		if (mobileColumnIndex === 1) {
			// Second column: show left and right arrows above the footer
			mobileFooterArrows = (
				<div style={navBarStyle} className="footer-arrows-bar">
					<button
						style={arrowBtnStyle}
						aria-label="Back"
						onClick={() => setMobileColumnIndex(0)}
					>
						<BsArrowLeftShort />
					</button>
					<button
						style={arrowBtnStyle}
						aria-label="More"
						onClick={() => setMobileColumnIndex(2)}
					>
						<BsArrowRightShort />
					</button>
				</div>
			);
		} else if (mobileColumnIndex === 2) {
			// Third column: show left arrow above the footer
			mobileFooterArrows = (
				<div style={navBarStyle}>
					<button
						style={arrowBtnStyle}
						aria-label="Back"
						onClick={() => {
							if (typeof props.clearCommentsMore === "function") {
								props.clearCommentsMore();
							}
							setMobileColumnIndex(1);
						}}
					>
						<BsArrowLeftShort />
					</button>
				</div>
			);
		}
	}

	return (
		<>
			<div id="footer" style={footerStyle}>
				{/* Always show arrows if appropriate */}
				{mobileFooterArrows}
					<SearchReddit
						showingTab={showingTab}
						setShowingTab={setShowingTab}
						setMobileColumnIndex={setMobileColumnIndex}
						mobileColumnIndex={mobileColumnIndex}
					/>
				{/* Footer buttons area, slide up/down on mobile */}
				<div
					id="button-show"
					className={
						isMobile()
							? showFooterButtons
								? "footer-buttons-visible"
								: "footer-buttons-hidden"
							: ""
					}
				>
					
					{showingTab === "saved" ? <SavedSubreddits setShowingTab={setShowingTab} /> : null}
					{showingTab === "visited" ? <VisitedSubreddits setShowingTab={setShowingTab} /> : null}
					<button >
						<Link to="/">r/Popular</Link>
					</button>
					<button style={{ fontWeight: showingTab === 'search' ? "bold" : "normal" }} id="menu-button" onClick={() => setShowingTab(showingTab === 'search' ? 'none' : 'search')}>
						Subreddit Search
					</button>
					{!isMobile() && (
						<>
							<button className="show-arrow" onClick={props.showColumn === 'comments' ? () => props.setShowColumn('none') : () => props.setShowColumn('comments')}>
								{props.showColumn === 'comments' ?
									<BsFillArrowRightSquareFill style={{ color: "#808080", fontSize: "20px", paddingBottom: 2 }} />
									: <BsArrowRightShort style={{ color: "#808080", fontSize: "20px", paddingBottom: 2 }} />
								}
							</button>
							<button className="show-arrow" onClick={props.showColumn === 'details' ? () => props.setShowColumn('none') : () => props.setShowColumn('details')}>
								{props.showColumn === 'details' ?
									<BsFillArrowLeftSquareFill style={{ color: "#808080", fontSize: "20px", paddingBottom: 2 }} />
									: <BsArrowLeftShort style={{ color: "#808080", fontSize: "20px", paddingBottom: 2 }} />
								}
							</button>
							<button className="show-thumbnail-arrows" onClick={props.hideArrows ? () => props.setHideArrows(false) : () => props.setHideArrows(true)}>{props.hideArrows ? <CgArrowsMergeAltH style={{ color: "#d1d1d1" }} /> : <CgArrowsMergeAltH style={{ color: "#4c4c4c" }} />}</button>
						</>
					)}
					<button style={{ fontWeight: showingTab === 'visited' ? "bold" : "normal" }} id="menu-button" onClick={() => setShowingTab(showingTab === 'visited' ? 'none' : 'visited')}>
						History
					</button>
					<button style={{ fontWeight: showingTab === 'saved' ? "bold" : "normal" }} id="menu-button" onClick={() => setShowingTab(showingTab === 'saved' ? 'none' : 'saved')}>
						Saved
					</button>
					<button className="show-thumbnails" onClick={props.hideThumbnails ? () => props.setHideThumbnails(false) : () => props.setHideThumbnails(true)}>{props.hideThumbnails ? <MdOutlineHideImage /> : <MdOutlineImage />}</button>
					<a id="chrome-bonus" target="_blank" rel="noreferrer" href="https://chrome.google.com/webstore/detail/megacomments-youtube-twit/pdbgnmokjckonepnfafnomiilfifcbhe?hl=en">
						<button >
							Chrome Bonus
						</button>
					</a>
					<Modal id=""
						style={{
							content: {
								bottom: "initial"
							}
						}}
						onRequestClose={toggleMenu}
						shouldCloseOnOverlayClick={true}
						isOpen={menu}
					>
						<button style={{ width: "100%" }} onClick={() => toggleMenu()}>
							close
						</button>
						<MainMenu closeMenu={closeMenu} />
						<button style={{ width: "100%" }} onClick={() => toggleMenu()}>
							close
						</button>
					</Modal>
					<button id="about-button" onClick={() => toggleAbout()}>
						About
					</button>
					<Modal
						style={{
							content: {
								bottom: "initial"
							}
						}}
						onRequestClose={toggleAbout}
						shouldCloseOnOverlayClick={true}
						isOpen={about}
					>
						<button style={{ width: "100%" }} onClick={() => toggleAbout()}>
							close
						</button>

						<About />
					</Modal>
					<button id="terms-button" onClick={() => toggleTerms()}>
						TOS
					</button>
					<Modal
						style={{
							content: {
								bottom: "initial"
							}
						}}
						onRequestClose={toggleTerms}
						shouldCloseOnOverlayClick={true}
						isOpen={terms}
					>
						<button style={{ width: "100%" }} onClick={() => toggleTerms()}>
							close
						</button>
						<Terms />
					</Modal>
					<hr id="footer-break" style={{ flexBasis: "100%", height: 0, margin: 0, border: 0, display: 'none' }} />
				</div>
			</div>
		</>
	)
}

const mapStateToProps = (state) => {
	return {
		rules: state.data.subreddit.rules,
		subreddit: state.data.subreddit.subreddit
	}
};

const mapDispatchToProps = (dispatch) => ({
	clearCommentsMore: () => dispatch(moreReducer.saveCommentsMore({ commentsMore: null }))
});

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
